module.exports = "/cyber/_next/static/images/winners-determination-bg-tablet-8d486d565615f0c583de33ea0852ff92.jpg";